import { Component, OnDestroy, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { syncAllGlobalAdminsAccess } from '../../store/global-settings.actions';
import { filter, Subscription } from 'rxjs';
import { openActionDialog } from 'src/app/shared/store/action-dialog/action-dialog.actions';
import { ActionDialogType } from 'src/app/shared/models/enums/action-dialog-type.enum';
import { MultiUsersSearchComponent } from 'src/app/shared/components/multi-users-search/multi-users-search.component';
import { loadAllGlobalAdminsAccess } from 'src/app/roles/_shared-by-role/global-settings/store/global-settings.actions';
import { selectAllGlobalAdmins } from 'src/app/roles/_shared-by-role/global-settings/store/global-settings.selectors';

@Component({
  standalone: false,
  selector: 'app-global-admin-access-dialog',
  templateUrl: './global-admin-access-dialog.component.html',
  styleUrls: ['./global-admin-access-dialog.component.scss'],
})
export class GlobalAdminAccessDialogComponent implements OnDestroy {
  @ViewChild(MultiUsersSearchComponent)
  multiUsersSearch!: MultiUsersSearchComponent;
  private readonly subscription = new Subscription();
  globalAdmins?: string[];
  private originalGlobalAdmins?: string[];
  readonly = true;

  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<GlobalAdminAccessDialogComponent>
  ) {
    this.store.dispatch(loadAllGlobalAdminsAccess());

    this.subscription.add(
      this.store
        .select(selectAllGlobalAdmins)
        .pipe(filter((x) => x != null))
        .subscribe((globalAdmins) => {
          this.originalGlobalAdmins = globalAdmins!;
          this.globalAdmins = globalAdmins!;
          this.multiUsersSearch.setValue(this.globalAdmins!);
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onGlobalAdminsChanged(globalAdmins: (string | null)[]) {
    this.globalAdmins = globalAdmins.filter((x) => x).map((x) => x!);
  }

  closeWindow() {
    this.dialogRef.close();
  }

  edit() {
    this.readonly = false;
  }

  cancel() {
    this.readonly = true;
    this.globalAdmins = this.originalGlobalAdmins;
    this.multiUsersSearch.setValue(this.globalAdmins!);
  }

  save() {
    this.store.dispatch(
      openActionDialog({
        title: 'confirm saved changes',
        description:
          "Please confirm that you'd like to save these changes. This action may impact all global admins and their access and permissions.",
        confirmButtonText: 'confirm changes',
        dialogType: ActionDialogType.Confirmation,
        onConfirm: () => {
          this.readonly = true;
          this.store.dispatch(
            syncAllGlobalAdminsAccess({ globalAdminsIds: this.globalAdmins! })
          );
        },
      })
    );
  }
}
